import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { IEvent } from '../interfaces';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

@Injectable()
export class EventService {

  private _event: BehaviorSubject<IEvent> = new BehaviorSubject<IEvent>(null);
  public readonly Event: Observable<IEvent> = this._event.asObservable();

  constructor(private http: HttpClient) { }

  /**
   * Get Event details
   * @param eventKey Shared registration key
   */
  public get(eventKey: string): Promise<IEvent> {
    if (this._event.value) {
      return Promise.resolve(this._event.value);
    }

    return this.http.get<IEvent>(`/api/event/v1/${eventKey}`).toPromise()
      .then((event) => {
        this._event.next(event);
        return event;
      }, (reason: any) => {
        this._event.error(reason);
        return Promise.reject(reason);
      });
  }
}
